import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  public login(auth_data: authData): Observable<any> {
    // Enviar una petición POST a la API para iniciar sesión
    //let url = 'https://wkvqd7vbe6.execute-api.us-east-1.amazonaws.com/QA/cl-university-console-backend/authenticate'
    let url = 'https://wkvqd7vbe6.execute-api.us-east-1.amazonaws.com/PROD/cl-university-console-backend/authenticate'
    return this.http.post<any>(url, 
    auth_data,
    {
      headers:{'content-type':'application/json'}
    })
  }
}

export interface authData {
  username: string;
  password: string;
}